import { render } from "./order_requests.vue?vue&type=template&id=6e1d025a&scoped=true"
import script from "./order_requests.vue?vue&type=script&lang=js"
export * from "./order_requests.vue?vue&type=script&lang=js"

import "./order_requests.vue?vue&type=style&index=0&id=6e1d025a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1d025a"]])

export default __exports__